import variables from '../../variables.module.scss';

const MuiMenuItem = {
  styleOverrides: {
    root: {
      fontFamily: variables.fontSemiBold,
      color: variables.headerLinksFontColor,
      '&:hover': {
        backgroundColor: variables.appBarTitleBackground,
      },
    },
  },
};

export default MuiMenuItem;
